<template>
	<div>
		<DaModalFrame v-model:open="editOpen">
			<CreateBoarding
				v-if="editOpen && classSelected"
				:boarding-data="classSelected"
				:staffs="employees"
				@close="editOpen = false"
				@update="updateClass"
			/>
		</DaModalFrame>
		<div
			class="fixed inset-y-0 right-0 flex side-over z-50"
			style="width: 720px; max-width: 100%"
		>
			<div
				class="
					h-full
					w-full
					flex flex-col
					bg-white
					shadow-xl
					overflow-y-auto
				"
			>
				<div class="px-6 py-8 bg-blue-50">
					<div class="flex items-start justify-between">
						<div class="flex items-center">
							<svg
								fill="none"
								height="24"
								viewBox="0 0 24 24"
								width="24"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									clip-rule="evenodd"
									d="M6 0.75C6 0.335786 5.66421 0 5.25 0C4.83579 0 4.5 0.335786 4.5 0.75V1.5H3C1.34315 1.5 0 2.84315 0 4.5V6H24V4.5C24 2.84315 22.6569 1.5 21 1.5H19.5V0.75C19.5 0.335786 19.1642 0 18.75 0C18.3358 0 18 0.335786 18 0.75V1.5H6V0.75ZM24 21V7.5H0V21C0 22.6569 1.34315 24 3 24H21C22.6569 24 24 22.6569 24 21ZM12.75 12.75C12.75 12.3358 12.4142 12 12 12C11.5858 12 11.25 12.3358 11.25 12.75V15H9C8.58579 15 8.25 15.3358 8.25 15.75C8.25 16.1642 8.58579 16.5 9 16.5H11.25V18.75C11.25 19.1642 11.5858 19.5 12 19.5C12.4142 19.5 12.75 19.1642 12.75 18.75V16.5H15C15.4142 16.5 15.75 16.1642 15.75 15.75C15.75 15.3358 15.4142 15 15 15H12.75V12.75Z"
									fill="#94A3B8"
									fill-rule="evenodd"
								/>
							</svg>
							<div
								class="
									text-xl
									font-bold
									text-neutral-700
									ml-2
									mt-1
								"
							>
								Chọn lớp để chỉnh sửa thời khoá biểu
							</div>
						</div>
						<button
							class="
								rounded-md
								text-neutral-400
								hover:text-neutral-700
							"
							type="button"
							@click="$emit('close')"
						>
							<span class="sr-only">Đóng</span>
							<svg
								aria-hidden="true"
								class="h-6 w-6"
								fill="none"
								stroke="currentColor"
								viewBox="0 0 24 24"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									d="M6 18L18 6M6 6l12 12"
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
								/>
							</svg>
						</button>
					</div>
				</div>
				<div class="relative flex-1 px-6 pb-20 mt-8">
					<div class="font-semibold text-neutral-600">
						Chọn lớp bán trú*
					</div>
					<div class="w-full mt-2">
						<Multiselect
							v-model="classSelected"
							:allow-empty="false"
							:max-height="300"
							:options="classOptions"
							:searchable="true"
							deselect-label="Đã chọn"
							label="nameSearch"
							placeholder="Tìm theo tên lớp bán trú"
							select-label=""
							track-by="id"
						>
							<template #noResult>
								Không tìm thấy kết quả
							</template>
							<template #option="props">
								<div>{{ props.option.name }}</div>
							</template>
							<template #singleLabel="{ option }">
								<div>{{ option.name }}</div>
							</template>
						</Multiselect>
					</div>
					<div v-if="classSelected" class="mt-6">
						<div class="flex items-center gap-2 text-lime-600">
							<DaIcon class="h-5 w-5" name="das--spoon" />
							<div class="font-semibold">
								{{ classSelected.name }}
							</div>
						</div>
						<div class="mt-8 font-semibold text-neutral-600">
							{{ $filters.terminology('teacher') }}
						</div>
						<div
							v-for="staff in classStaffs"
							:key="staff.id"
							class="mt-3 flex items-center"
						>
							<img
								v-if="staff.profile_photo?.w200"
								:src="staff.profile_photo.w200"
								alt=""
								class="
									shadow-sm
									inline-block
									h-6
									w-6
									rounded-full
								"
							/>
							<span
								v-else
								:style="{
									background:
										staff.profile_photo?.default?.color,
								}"
								class="
									inline-flex
									items-center
									justify-center
									h-6
									w-6
									rounded-full
								"
							>
								<span
									class="
										font-medium
										leading-none
										text-white text-xs
									"
									>{{
										staff.profile_photo?.default?.initial
									}}</span
								>
							</span>
							<div class="ml-4 text-blue-600 font-semibold">
								{{ staff.name }}
							</div>
						</div>
						<button
							class="button-p btn--text w-fit mt-4"
							type="button"
							@click="editOpen = true"
						>
							Thêm {{ $filters.terminology('teacher') }}
						</button>
					</div>
				</div>
				<div
					class="
						px-6
						py-4
						border-t border-yellow-50
						flex
						justify-end
					"
				>
					<button
						:disabled="!classSelected"
						class="button-p text-center w-32"
						type="button"
						@click="$emit('submit', classSelected)"
					>
						Tiếp tục
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import Multiselect from '@suadelabs/vue3-multiselect';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import CreateBoarding from '@/views/setupCenter/features/boarding/features/createBoarding/CreateBoarding.vue';
import { $api } from '@/services';
import { toEnglish } from '@/helper/toEnglish';

export default defineComponent({
	name: 'ChooseDaycareClass',
	components: { Multiselect, DaIcon, DaModalFrame, CreateBoarding },
	props: {
		open: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			classes: [],
			employees: [],
			classSelected: null,
			editOpen: false,
		};
	},
	computed: {
		classOptions() {
			return this.classes.map((item) => ({
				...item,
				nameSearch: toEnglish(item?.name),
			}));
		},
		classStaffs() {
			return this.classSelected?.staffs || [];
		},
	},
	watch: {
		open(value) {
			if (!value) return;
			this.classSelected = null;
			this.editOpen = false;
			this.fetchClasses();
			this.fetchEmployees();
		},
	},
	methods: {
		async fetchClasses() {
			try {
				const {
					data: { data },
				} = await $api.boarding.getDayCareClasses();
				this.classes = data || [];
			} catch (err) {
				this.$store.dispatch('setAlertMessage', {
					message:
						err?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},
		async fetchEmployees() {
			try {
				const {
					data: { data },
				} = await $api.staff.getEmployees('');
				this.employees = data || [];
			} catch (err) {
				this.employees = [];
			}
		},
		async updateClass(value) {
			try {
				await Promise.all([
					$api.boarding.updateDayCareClass(value.id, {
						day_care_class: {
							name: value.name,
						},
					}),
					$api.boarding.addStaffToDaycareClass({
						staff_memberships: {
							day_care_class_id: value.id,
							staff_ids: value.staff_ids,
						},
					}),
				]);
				await this.fetchClasses();
				this.classSelected =
					this.classOptions.find((item) => item.id === value.id) ||
					null;
				this.editOpen = false;
				this.$store.dispatch('setAlertMessage', {
					message: 'Chỉnh sửa lớp bán trú thành công',
				});
			} catch (err) {
				this.$store.dispatch('setAlertMessage', {
					message:
						err?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},
	},
});
</script>
